export function fmtEur(n: number): string {
  if (n >= 1_000_000) return `€${(n / 1_000_000).toFixed(2)}m`;
  if (n >= 1_000) return `€${(n / 1_000).toFixed(1)}k`;
  return `€${Math.round(n)}`;
}

export function fmtGbp(n: number): string {
  if (n >= 1_000_000) return `£${(n / 1_000_000).toFixed(2)}m`;
  if (n >= 1_000) return `£${(n / 1_000).toFixed(1)}k`;
  return `£${Math.round(n)}`;
}

export function fmtPct(n: number, digits = 3): string {
  return `${n.toFixed(digits)}%`;
}

export function shortMonth(yyyyMm: string): string {
  const [, m] = yyyyMm.split("-");
  return ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"][Number(m) - 1] ?? m;
}

export function relativeTime(iso: string, now: string): string {
  const t = new Date(iso).getTime();
  const n = new Date(now).getTime();
  const diff = Math.max(0, n - t);
  const s = Math.round(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  return `${d}d ago`;
}
